
import * as D from '../data-utils';


import $ from 'jquery';
import App from '../app';
import Events from '../events';
import './PathNode';
import './FloorChangeNode';
import './PathLink';
import './FloorRoute';
import Constants from './Constants';
import Wayfinding from './Wayfinding';
import './Direction';
import HistoryAPI from '../history';
let history;

  var mapdata = {};

  var context;


  function init(appContext, refreshMapFunc){
    context = appContext;
    var langs = D.langs();
    var lang = D.lang();
    var translations = App.getTranslations(langs);
    var scimddata = D.scimddata();
    var imddata = getImdData(context);
    var floors = getFloors();
    var services = getServices();

    const { mapType, scid, feature } = context.imdSettings;

    if (mapType.inhouse) {
      Wayfinding.init(scimddata, imddata, context);
    }

    mapdata.mapType = mapType;
    mapdata.feature = feature;

    mapdata.imddata = imddata;
    mapdata.floorIndex = imddata.floorIndex;
    mapdata.floorId = getFloorId(imddata.floorIndex);
    mapdata.imdFloorId = getFloorId(imddata.floorIndex);
    mapdata.title = getFloorTitle(floors, mapdata.floorId);
    mapdata.scid = scid;
    mapdata.scimddata = scimddata;
    mapdata.floors = floors;
    mapdata.iconsvg = context.resources.get('ic_map-pin');
    mapdata.icontitle = translations[lang]['common.map'];
    mapdata.translations = translations;
    mapdata.currentLang = lang;
    mapdata.currentRoute = {};
    mapdata.serviceTypes = services;
    mapdata.activeServiceType = {};
    mapdata.dots = [];
    mapdata.icons = [];
    mapdata.storemenu = {};
    mapdata.servicemenu = {};
    mapdata.serviceLocationMenu = {};
    mapdata.services = [];
    mapdata.closestService = {};
    mapdata.closestStore = [];
    mapdata.startPoint = {};
    mapdata.routes = [];
    mapdata.showGuiding = false;
    mapdata.showRouteDots = false;
    mapdata.store = {};
    mapdata.service = {};
    mapdata.activeStoreSpace = '';
    mapdata.twoFingerSupport = Constants.TWO_FINGER_SUPPORT;
    mapdata.svgPan = {};
    mapdata.svgZoom = 0;
    mapdata.zoomArea = {};
    mapdata.playRoute = {};
    mapdata.playRoute.play = false;
    mapdata.playRoute.currentRoute = {};
    mapdata.playRoute.finished = false;

    history = new HistoryAPI('#maps', {
      translations,
      scimddata,
      iconsvg: mapdata.iconsvg,
      imddata,
      floors,
      services
    });

    setStartView();
    const currentStore = App.getStoredData('currentStore', 'all');
    const { store, facility, showRoute = false } = currentStore;
    const isSet = Object.keys(store || {}).length > 0 || facility;
    mapdata.poi = isSet ? {
      facility,
      store: store,
      showRoute
    } : null;
    if (mapType.inhouse) {
      getCurrentStore(refreshMapFunc);

      if (facility) {
        locateService(facility);
      }
    }
    return mapdata;
  }

  function getMapData(){
    return mapdata;
  }
  function getCurrentStore(refreshMapFunc){
    var currentStore = App.getStoredData('currentStore', 'all');
    if(!$.isEmptyObject(currentStore)){
      if(currentStore.showRoute){
        getRouteToStore(currentStore.store);
        refreshMapFunc();
      }else{
        if(currentStore.storeLocation != undefined){
          setActiveStoreSpace(currentStore.storeLocation.storeSpaceId);
          mapdata.floorIndex = currentStore.storeLocation.floorIndex;
          Events.dispatchEvent('poi', { name: currentStore.store.name, action: 'location' });
        }
        mapdata.floorId = getFloorId(mapdata.floorIndex);
        setIcons();

      }
    }
  }

  function getFloors(){
    var lang = D.lang();
    var scdata = App.getStoredData('scdata', lang);
    var floors = scdata.shoppingCenterData.floors;
    floors = sortArray(floors, 'order', false);
    return scdata.shoppingCenterData.floors;
  }
  function sortArray(array, prop, asc) {
    var sorted = array.sort(function(a, b) {
      if (asc) {
        return (a[prop] > b[prop]) ? 1 : ((a[prop] < b[prop]) ? -1 : 0);
      } else {
        return (b[prop] > a[prop]) ? 1 : ((b[prop] < a[prop]) ? -1 : 0);
      }
    });
    return sorted;
  }
  function getStores(){
    var lang = D.lang();
    var storefeed = App.getStoredData('storelist', lang);
    return storefeed.stores;
  }

  function getStoreData(floorIndex) {
    const testFloor = typeof floorIndex === 'number';
    const stores = getStores();
    return stores.reduce(
      (acc, { name, storeLocations = [] }) => {
        const locations = storeLocations
          .filter(x => typeof x.pinLocation != 'undefined' &&
                       typeof x.storeSpaceId != 'undefined' &&
                       // See 4.3 in https://drive.google.com/open?id=0B2HMkuxiSU0AY25rTlR0ZTdqajA
                       (x.mapVisibility == 1 || x.mapVisibility == 4) &&
                       (testFloor ? x.floorIndex === floorIndex : true)
          )
          .map(loc => ({
            id: `storePath-${loc.storeSpaceId}`,
            name: name,
            center: [loc.pinLocation.x, loc.pinLocation.y]
          }));
        return acc.concat(locations);
      }, []
    );
  }

  function getServices(){
    var serviceLocations = getServiceLocations();

    var availableServices = $.map(Constants.SERVICE_TYPES, function(service){
      var availableService = {};
      $.each(serviceLocations, function(i, serviceLocation){
        if(serviceLocation.serviceType == service.id){
          availableService = service;
        }
      });
      if(!$.isEmptyObject(availableService)){
        return availableService;
      }
    });
    return availableServices;
  }

  function getServiceLocations(){
    return D.servicelocations();
  }

  function getServiceIcons(){
    var serviceLocations = getServiceLocations();

    var serviceIcons = [];
    $.each(Constants.SERVICE_TYPES, function(i, servicetype){
      $.each(serviceLocations, function(j, serviceLocation){
        if(serviceLocation.serviceType == servicetype.id){
          var service = {id: servicetype.id, icon: servicetype.icon, name: servicetype.name, pinicon: servicetype.pinicon, pinLocation: serviceLocation.pinLocation, floorIndex: serviceLocation.floorIndex};
          serviceIcons.push(service);
        }
      });
    });
    return serviceIcons;
  }

  /* GET IMD DATA*/
  function getImdData(context){
    let x, y, floorIndex, rotation, maxDirectionDistance, minDirectionDistance;

    const { imds } = D.scimddata();

    for(var i in imds){
      if(imds[i].id == context.imdId){
        x = imds[i].coordinates.x;
        y = imds[i].coordinates.y;
        floorIndex = getFloorIndex(imds[i].floorId);
        rotation = getRotation(imds[i].direction);
        maxDirectionDistance = imds[i].maxDirectionDistance;
        minDirectionDistance = imds[i].minDirectionDistance;
      }
    }

    return {
      floorIndex,
      rotation,
      x,
      y,
      maxDirectionDistance,
      minDirectionDistance
    };
  }


  function getRotation(direction){
    var rotate = direction + 90;
    if(rotate > 360){
      rotate = rotate-360;
    }
    return rotate * -1;
  }
  /*SET IMD*/
  function setStartView(){

    var f = getFloors();
    var currentFloorIndex = mapdata.imddata.floorIndex;

    var startPoint = {floorIndex: currentFloorIndex, x: mapdata.imddata.x, y: mapdata.imddata.y};
    mapdata.startPoint = startPoint;

    if (mapdata.mapType.inhouse) {
      Wayfinding.doFindShortestPathTree(currentFloorIndex, startPoint);
      setIcons();
    }
  }
  /* GET FLOOR ID */
  function getFloorId(floorIndex){
    var floors = getFloors();
    for(var f in floors){
      if(floors[f].order==floorIndex){
        return floors[f].id;
      }
    }
  }
  function getFloorIndex(floorId){
    var floors = getFloors();
    for(var f in floors){
      if(floors[f].id==floorId){
        return floors[f].order;
      }
    }
  }

  const takeLast = arr => arr[arr.length - 1];

  const normalizeStoreId = id =>
    Number.isInteger(id) ? id :
      takeLast(id.split('storePath-'));

  function showStoreMenu(svgStoreId, svg, left, top, maxX, maxY){

    var storeId = normalizeStoreId(svgStoreId);
    var stores = getStores();
    $.each(stores, function(i, store){
      $.each(store.storeLocations, function(j, locations){
        if (locations.storeSpaceId == storeId && mapdata.floorIndex == locations.floorIndex){

          var orientation = getOrientationForPopup(svg, left, top, maxX, maxY);

          Events.dispatchEvent('poi', { name: store.name, action: 'popup' });
          setActiveStoreSpace(storeId);
          mapdata.storemenu = {id: store.id, name: store.name, logo: store.logoURL, x: orientation.left, y: orientation.top, orientationClass: orientation.orientationClass };
        }
      });
    });
  }

  function showStoreMenuByStoreId(storeId, view, left, top, maxX, maxY){

    const store = getStores().find(store => store.id == storeId);
    if (store) {
      const orientation = getOrientationForPopup(view, left, top, maxX, maxY);
      mapdata.storemenu = {
        id: store.id,
        name: store.name,
        logo: store.logoURL,
        x: orientation.left,
        y: orientation.top,
        orientationClass: orientation.orientationClass
      };
    }
  }

  function showServiceMenu(id, hideClosest, hideRoute, type){
    const serviceType = getServiceType(id);

    const servicename = serviceType.name;
    const icon = serviceType.icon;
    mapdata.servicemenu = {id: id, name: servicename, hideClosest: hideClosest, hideRoute: hideRoute, icon: icon, type: 'non-modal'};
  }

  function showModalServiceMenu(id){
    const servicename = getServiceType(id).name;
    mapdata.servicemenu = {id: id, name: servicename, type: 'modal'};
  }

  function showServiceLocationMenu(id, serviceid, svg, left, top, maxX, maxY, iconWidth){
    const serviceType = getServiceType(serviceid);
    const servicename = serviceType.name;

    $.each(mapdata.icons, function(i, icon){
      icon.class = icon.class.replace('active', '');
      if(icon.id == id){
        icon.class = 'highlight '+icon.class;
      }
    });

    mapdata.icons = sortArray(mapdata.icons, 'class', false);

    var orientation = getOrientationForPopup(svg, left, top, maxX, maxY, iconWidth);

    mapdata.serviceLocationMenu = {
      poi: id,
      id: serviceid,
      name: servicename,
      x: orientation.left, y: orientation.top,
      bottom: orientation.bottom,
      orientationClass: orientation.orientationClass
    };
  }

  function getOrientationForPopup(svg, left, top, maxX, maxY, iconWidth){

    var popup_left = left - svg.left - (Constants.STOREMENU.width/2);
    var popup_right = left - svg.left + (Constants.STOREMENU.width/2);
    var popup_top = top - svg.top + Constants.STOREMENU.linewidth;

    var popup_height = Constants.STOREMENU.height;
    if(iconWidth){
      popup_height = Constants.STOREMENU.oneItemheight;
    }

    var orientationClass = 'bottom';

    //if popup position exeed area on right, flip it to the left
    if(popup_right > maxX){
      popup_top -= popup_height/2 + Constants.STOREMENU.linewidth;
      popup_left -= Constants.STOREMENU.width/2 + Constants.STOREMENU.linewidth + Constants.STOREMENU.margin + 10;
      popup_left -= (iconWidth) ? iconWidth/2 : 0;

      //if new postion exceed area on top, flip it to the bottom-left
      if(popup_top < 0){
        popup_top += popup_height/2 + Constants.STOREMENU.linewidth - Constants.STOREMENU.margin/2;
        popup_left += Constants.STOREMENU.margin + Constants.STOREMENU.margin/2;
        orientationClass  = 'bottom-left';
      }else{
        orientationClass  = 'left';
      }
    }

    //if popup position exceed area on left, flip it on the right
    if(popup_left < 0){
      popup_top -= popup_height/2 + Constants.STOREMENU.linewidth;
      popup_left += Constants.STOREMENU.width/2 + Constants.STOREMENU.linewidth;
      popup_left += (iconWidth) ? iconWidth/2 : 0;

      //if new position exceed area on top, flip it to the bottom-right
      if(popup_top < 0){
        popup_top += popup_height/2 + Constants.STOREMENU.linewidth - Constants.STOREMENU.margin/2;
        popup_left -= Constants.STOREMENU.margin + Constants.STOREMENU.margin/2;
        orientationClass  = 'bottom-right';
      }else{
        orientationClass  = 'right';
      }
    }

    var popup_bottom = popup_top + popup_height;

    //if popup postion exceed area on bottom, flip it on the top
    if(popup_bottom > maxY){
      popup_left -= Constants.STOREMENU.margin;
      popup_top -= (iconWidth) ? iconWidth/2 : 0;
      if(orientationClass  == 'right'){
        popup_left -= Constants.STOREMENU.margin/2;
        popup_top -= popup_height/2;
        orientationClass = 'top-right';
      }else if(orientationClass == 'left'){
        popup_left += Constants.STOREMENU.margin/2 + Constants.STOREMENU.margin + 10;
        popup_top -= popup_height/2 + Constants.STOREMENU.margin;
        orientationClass = 'top-left';
      }else{
        popup_top -= popup_height + Constants.STOREMENU.linewidth + Constants.STOREMENU.margin;
        popup_top -= (iconWidth) ? iconWidth/2 : 0;
        orientationClass  = 'top';
      }
    }

    if(orientationClass == 'bottom'){
      popup_top += (iconWidth) ? iconWidth/2 : 0;
      popup_left -= Constants.STOREMENU.margin;
    }
    return {orientationClass: orientationClass, left: popup_left, top: popup_top};
  }

  function getStore(id){
    var stores = getStores();
    for(var s in stores){
      if(stores[s].id==id){
        return stores[s];
      }
    }
  }
  function getFloorTitle(floors, floorId){
    var title;
    for(var i in floors){
      if(floors[i].id==floorId){
        title = floors[i].description;
      }
    }
    return title;
  }
  function setFloor(floorId){
    saveState();
    clear();
    mapdata.floorId=floorId;
    mapdata.floorIndex = getFloorIndex(floorId);
    mapdata.title = getFloorTitle(mapdata.floors, floorId);
    setIcons();
  }

  function showGuidingAgain(){
    mapdata.dots=[];
    var service = mapdata.closestService;
    var store = mapdata.store;

    var floorId = getFloorId(mapdata.imddata.floorIndex);
    setFloor(floorId);

    if(!$.isEmptyObject(store)){
      getRouteToStore(store);
    }else if(!$.isEmptyObject(service)){
      mapdata.routes = Wayfinding.doFindShortestPath(service.floorIndex, mapdata.startPoint, service.pinLocation, mapdata.imddata.minDirectionDistance, mapdata.imddata.maxDirectionDistance);
      mapdata.servicemenu = {};
      mapdata.closestService = service;
      mapdata.service = service;
    }
    showGuiding();
  }
  function showGuiding(){

    mapdata.showGuiding = true;
    mapdata.floorIndex = mapdata.imddata.floorIndex;
    mapdata.floorId = getFloorId(mapdata.imddata.floorIndex);
    mapdata.title = getFloorTitle(mapdata.floors, mapdata.floorId);

    if(mapdata.routes.length == 0 ) {
      mapdata.routeNotFound = true;
      return;
    }

    const lastRoute = mapdata.routes[mapdata.routes.length - 1];
    const firstRoute = mapdata.routes[0];

    mapdata.targetFloorIndex = lastRoute.FloorIndex;
    mapdata.targetFloorName = Wayfinding.getFloorName(mapdata.targetFloorIndex);
    mapdata.imdFloorIndex = Wayfinding.getFloorIndex(mapdata.imdFloorId);
    mapdata.imdFloorName = Wayfinding.getFloorName(mapdata.imdFloorIndex);

    playRoute(true);
  }
  function updateGuiding(index){
    if(index){
      mapdata.currentRoute = mapdata.routes.find((step) => {
        return step.Num == parseInt(index);
      });

      const route = mapdata.currentRoute;

      var routemarks = Wayfinding.drawPaths(mapdata.currentRoute);
      mapdata.dots = routemarks.dots;
      mapdata.floorIndex = route.FloorIndex;
      mapdata.floorId = getFloorId(route.FloorIndex);
      mapdata.title = getFloorTitle(mapdata.floors, mapdata.floorId);

      mapdata.showRouteDots = true;

      if(mapdata.floorIndex == mapdata.closestService.floorIndex){
        showServiceLocation(mapdata.closestService);
      }else{
        setIcons();
        $.each(mapdata.icons, function(i, icon){
          hideIcon(icon);
        });
      }

      mapdata.icons = routemarks.icons;
      mapdata.icons.forEach(icon => activateIcon(icon));

    } else{
      if(mapdata.floorIndex == mapdata.closestService.floorIndex){
        showServiceLocation(mapdata.closestService);
      }
    }

  }

  function showRouteToServiceId(serviceId){
    const serviceType = getServiceType(serviceId);
    showRouteToService(serviceType);
  }

  function showRouteToService(serviceType){
    const closestServiceLocation = Wayfinding.findClosestServiceLocation(serviceType);
    showRouteToServiceLocation(closestServiceLocation, serviceType);
  }

  function showRouteToThisServiceId(serviceId, location){
    const serviceType = getServiceType(serviceId);
    const [x, y] = location.split('x');
    const targetService = getServiceLocations().find(serviceLocation => serviceLocation.serviceType == serviceId && serviceLocation.pinLocation.x == x && serviceLocation.pinLocation.y == y && serviceLocation.floorIndex == mapdata.floorIndex);
    showRouteToServiceLocation(targetService, serviceType);
  }

  function showRouteToServiceLocation(serviceLocation, serviceType) {
    const imdFloorId = getFloorId(mapdata.imddata.floorIndex);
    setFloor(imdFloorId);

    const floorIndex = serviceLocation.floorIndex;
    const point = serviceLocation.pinLocation;
    mapdata.routes = Wayfinding.doFindShortestPath(floorIndex, mapdata.startPoint, point, mapdata.imddata.minDirectionDistance, mapdata.imddata.maxDirectionDistance);
    mapdata.routes[mapdata.routes.length - 1].EndIcon = serviceType.pinicon;
    mapdata.closestService = serviceLocation;
    mapdata.servicemenu = {};
    mapdata.serviceLocationMenu = {};
    mapdata.service = serviceType;
    showGuiding();

    Events.dispatchEvent('service:route', serviceType);
    Events.dispatchEvent('poi', { name: serviceType.name, action: 'route' });
  }

  function showRouteToStore(id){
    const store = getStore(id);
    const floorId = getFloorId(mapdata.imddata.floorIndex);
    mapdata.storemenu = {};
    setFloor(floorId);
    getRouteToStore(store);
  }

  function getRouteToStore(store){
    var closestStore = Wayfinding.findClosestStoreLocationForStore(store);
    var floorIndex = closestStore.floorIndex;
    var point = closestStore.doorLocation;
    mapdata.routes = Wayfinding.doFindShortestPath(floorIndex, mapdata.startPoint, point, mapdata.imddata.minDirectionDistance, mapdata.imddata.maxDirectionDistance);
    mapdata.closestStore = closestStore;
    showGuiding();
    mapdata.storemenu = {};
    mapdata.store = store;
    setActiveStoreSpace(closestStore.storeSpaceId);
    Events.dispatchEvent('poi', { name: store.name, action: 'route' });
  }

  function showRoute(routes){
    var count = 0;
    for(var i=0; i<routes.length; i++){
      if(typeof routes[i]!='undefined'){
        Wayfinding.drawPaths(routes[i]);
      }
    }
  }

  function showServiceLocation(closestService){
    const serviceType = getServiceType(closestService.serviceType);

    mapdata.floorIndex = closestService.floorIndex;
    mapdata.floorId = getFloorId(closestService.floorIndex);
    mapdata.closestService = closestService;
    setIcons();

    mapdata.icons.forEach(icon => (icon.x == closestService.pinLocation.x && icon.y == closestService.pinLocation.y) ? activateIcon(icon) : hideIcon(icon));

    Events.dispatchEvent('service:closest:show', serviceType);
    Events.dispatchEvent('poi', { name: serviceType.name, action: 'route' });
  }

  function activateIcon(icon) {
    icon.class = ' active ' + icon.class;
    icon.class = icon.class.replace('icon--hidden', '');
  }

  function hideIcon(icon) {
    // Never hide IMD location
    if(icon.id == 'you-are-here') {
      return;
    }

    if(!icon.class.includes('icon--hidden')) {
      icon.class += ' icon--hidden ';
    }
    icon.class = icon.class.replace('active', '');
  }

  function activateServiceLocations(serviceType){

    var left = 0;
    var top = 0;
    var bottom = 0;
    var right = 0;
    var distance = 0;
    var middlePoint = {};

    setIcons();

    $.each(mapdata.icons, function(i, icon) {
      icon.class = icon.class.replace('active', ''); //remove activity
      if(!icon.class.includes('icon--hidden') && !icon.path.includes('pin_you-are-here')) {
        hideIcon(icon);
      }
      if(i==0){
        left = icon.x;
        right = icon.x;
        top = icon.y;
        bottom = icon.y;
      }

      if(icon.name == serviceType.pinicon || icon.id=='you-are-here'){

        if(icon.x < left) left = icon.x;
        if(icon.x > right) right = icon.x;
        if(icon.y < top) top = icon.y;
        if(icon.y > bottom) bottom = icon.y;
      }

      if(icon.name == serviceType.pinicon ){
        activateIcon(icon);
      }

    });

    mapdata.icons = sortArray(mapdata.icons, 'class', false);

    //calculate the middle point and the length of the route
    var distanceX = right-left;
    var distanceY = bottom - top;
    distance = (distanceX > distanceY ? distanceX : distanceY);

    middlePoint = {x: left + distanceX/2, y: top + distanceY/2};
    mapdata.zoomArea = {middlePoint: middlePoint};

    Events.dispatchEvent('service:highlight', serviceType);
  }

  function locateService(id){
    const serviceType = getServiceType(id);
    mapdata.closestService = {};
    mapdata.servicemenu = {};
    var closestService = Wayfinding.findClosestServiceLocation(serviceType);
    showServiceLocation(closestService);
  }

  function toggleService(activeServiceType, serviceId){
    const serviceType = getServiceType(serviceId);

    if(activeServiceType.id == serviceType.id) {
      // If same service is selected, clear everything and reset to imd floor
      mapdata.zoomArea.middlePoint = {x: mapdata.imddata.x, y: mapdata.imddata.y};
      setFloor(mapdata.imdFloorId);
      return;
    } else {
      mapdata.activeServiceType = serviceType;
    }

    const serviceOnCurrentFloor = getClosestServiceOnFloor(mapdata.floorIndex, serviceType);
    const serviceOnIMDFloor = getClosestServiceOnFloor(mapdata.imddata.floorIndex, serviceType);

    //IMD IS LOCATED ON CURRENT FLOOR
    if(mapdata.imddata.floorIndex == mapdata.floorIndex){
      //one or more selected servicetypes can be found on current floor
      if(serviceOnCurrentFloor){
        //highlight all services
        activateServiceLocations(serviceType);
        //show menu
        showServiceMenu(serviceId,true);
      }else{
        //Service can not be found on this floor -> show popup
        showModalServiceMenu(serviceId);
      }
    }
    //IMD IS NOT LOCATED ON CURRENT FLOOR
    else{
      //Service is available in both floors or service is available in map’s floor
      if(serviceOnCurrentFloor && serviceOnIMDFloor || serviceOnCurrentFloor){
        //highlight all services
        activateServiceLocations(serviceType);
        //show menu
        showServiceMenu(serviceId, true);
      }
      //Service is available SAME floor with IMD or service is available in SOME OTHER third floor
      else{
        //Service can not be found on this floor -> show popup
        showModalServiceMenu(serviceId);
      }
    }
  }

  function getClosestServiceOnFloor(floorIndex, serviceType){

    var services = getServiceLocations();
    var servicesOnFloor = $.map(services, function(service){
      if(service.floorIndex === floorIndex && service.serviceType === serviceType.id){
        return service;
      }
    });

    var closest;
    if(servicesOnFloor.length === 1){
      closest = servicesOnFloor[0];
    }else if(servicesOnFloor.length > 1){
      closest = Wayfinding.findClosestServiceLocation(serviceType);
    }

    return closest;
  }

  function setIcons(){
    const { mapType } = mapdata;
    if (mapType && mapType.inhouse) {
      var services = getServiceIcons();
      let icons = Wayfinding.drawStartNodes(mapdata.floorIndex, mapdata.startPoint, services);
      icons.forEach(icon => {
        hideIcon(icon);
      });
      mapdata.icons = icons;
      mapdata.icons = sortArray(mapdata.icons, 'class', false);
    }
  }

  function saveZoom(zoom){
    mapdata.svgZoom = zoom;
  }

  function savePan(pan){
    mapdata.svgPan = pan;
  }

  function updateState(){
    history.updateState(mapdata);
  }

  function saveState(){
    history.saveState(mapdata);
  }

  function goBack(){
    const [historyState, state] = history.goBack();
    mapdata = state || mapdata;
    return !!historyState;
  }

  function goToStore(id){
    mapdata.store = id;
    var storelist = App.getStoredData('currentStorelist', 'all');
    storelist.store = id;
    App.saveLocally(storelist, 'currentStorelist', 'all');
    window.location.href='#store';
  }

  function setActiveStoreSpace(storeSpaceId){
    mapdata.activeStoreSpace = 'storePath-'+storeSpaceId;
  }

  function playRoute(play) {
    mapdata.playRoute.finished = false;
    mapdata.playRoute.currentRoute = {};
    mapdata.playRoute.play = play;
  }

  const getServiceType = (serviceId) => Constants.SERVICE_TYPES.find(service => service.id == serviceId);

  function clear(){
    mapdata.dots = [];
    mapdata.storemenu = {};
    mapdata.servicemenu = {};
    mapdata.serviceLocationMenu = {};
    mapdata.closestService = {};
    mapdata.closestStore = [];
    mapdata.routes = [];
    mapdata.showGuiding = false;
    mapdata.routeNotFound = false;
    mapdata.store = {};
    mapdata.service = {};
    mapdata.activeServiceType = {};
    mapdata.activeStoreSpace = '';
    mapdata.svgZoom = 0;
    mapdata.svgPan = {};

    mapdata.currentRoute = {};
    mapdata.playRoute = {};
    mapdata.playRoute.play = false;
    mapdata.playRoute.finished = false;
    mapdata.playRoute.currentRoute = {};

    setIcons();
  }

  export default {
    clear,
    getFloorId,
    getFloorIndex,
    getFloors,
    getImdData,
    getMapData,
    getStore,
    getStoreData,
    getStores,
    goBack,
    goToStore,
    init,
    locateService,
    playRoute,
    savePan,
    saveState,
    saveZoom,
    setFloor,
    showGuidingAgain,
    showRouteToService,
    showRouteToServiceId,
    showRouteToServiceLocation,
    showRouteToStore,
    showRouteToThisServiceId,
    showServiceLocation,
    showServiceLocationMenu,
    showServiceMenu,
    showModalServiceMenu,
    showStoreMenu,
    showStoreMenuByStoreId,
    toggleService,
    updateGuiding,
    updateState
  };
